"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _logger = require("@insided/shared/services/logger");

var _userService = require("./userService");

var _ConfigContext = require("@insided/shared/services/ConfigContext");

var _UserNotes = _interopRequireDefault(require("./UserNotes"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Modal = require("@insided/shared/uikit/Modal/Modal");

var _ModalBody = require("@insided/shared/uikit/Modal/ModalBody");

var _ModalHeader = require("@insided/shared/uikit/Modal/ModalHeader");

var _LabelText = _interopRequireDefault(require("@insided/shared/uikit/LabelText"));

var _inputUnit = require("@insided/deprecated-preact-components/design-system-components/input-unit");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

var _Skeleton = require("@insided/shared/uikit/Skeleton");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PostAuthor = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('@insided/control/modules/ContentModeration/TopicModeration/post/PostAuthor.lazy');

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})), {
  fallback: (0, _preact.h)(_Skeleton.RectangleSkeleton, {
    width: "100%",
    height: "120px"
  })
});

var ListItem = function ListItem(_ref2) {
  var title = _ref2.title,
      value = _ref2.value,
      key = _ref2.key;
  return (0, _preact.h)("li", {
    key: key
  }, (0, _preact.h)("span", {
    className: "list-item-label"
  }, title), (0, _preact.h)("span", {
    className: "list-item-value"
  }, value));
};

var ProfileModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProfileModal, _Component);

  var _super = _createSuper(ProfileModal);

  function ProfileModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ProfileModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _objectSpread(_objectSpread({}, _this.props.profileData), {}, {
      author: _this.props.author,
      userNoteInput: '',
      errors: null,
      isLoading: false
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteUserAvatar", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var authorId;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              authorId = _this.props.authorId;
              _context2.prev = 1;
              _context2.next = 4;
              return (0, _userService.deleteAvatar)(authorId);

            case 4:
              _this.setState(function (prevState) {
                return {
                  author: _objectSpread(_objectSpread({}, prevState.author), {}, {
                    avatar: ''
                  })
                };
              });

              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              _logger.logger.error(_context2.t0, {
                component: 'ProfileModal',
                action: 'deleteUserAvatar'
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeUserNoteInput", function (userNoteInput) {
      _this.setState({
        userNoteInput: userNoteInput
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addUserNote", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var userNoteInput, authorId, userNote;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              userNoteInput = _this.state.userNoteInput;
              authorId = _this.props.authorId;

              if (!(userNoteInput.length < 3)) {
                _context3.next = 5;
                break;
              }

              _this.setState({
                errors: {
                  userNote: 'Your message need to contain at least 3 characters'
                }
              });

              return _context3.abrupt("return");

            case 5:
              _this.setState({
                isLoading: true,
                errors: {
                  userNote: ''
                }
              });

              _context3.prev = 6;
              _context3.next = 9;
              return (0, _userService.saveUserNote)(userNoteInput, authorId);

            case 9:
              userNote = _context3.sent;

              _this.onChangeUserNoteInput('');

              _this.setState(function (prevState) {
                var updatedUserNotes = [].concat((0, _toConsumableArray2.default)(prevState.userNotes), [userNote]);
                return {
                  userNotes: updatedUserNotes
                };
              });

              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](6);

              _logger.logger.error(_context3.t0, {
                component: 'ProfileModal',
                action: 'addUserNote'
              });

            case 17:
              _this.setState({
                isLoading: false
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[6, 14]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(ProfileModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          profileData = _this$props.profileData,
          onClose = _this$props.onClose,
          author = _this$props.author,
          badges = _this$props.badges,
          reputationLevel = _this$props.reputationLevel,
          rank = _this$props.rank,
          isBanned = _this$props.isBanned,
          showBanUserModal = _this$props.showBanUserModal,
          authorId = _this$props.authorId,
          banUser = _this$props.banUser;
      var username = profileData.username,
          joinDate = profileData.joinDate,
          isSelf = profileData.isSelf,
          email = profileData.email,
          userStatistics = profileData.userStatistics,
          profileFields = profileData.profileFields,
          ssoProviders = profileData.ssoProviders;
      var followers = userStatistics.followers,
          following = userStatistics.following,
          topicCount = userStatistics.topicCount,
          replyCount = userStatistics.replyCount,
          answerCount = userStatistics.answerCount;
      var _this$state = this.state,
          userNoteInput = _this$state.userNoteInput,
          errors = _this$state.errors,
          userNotes = _this$state.userNotes,
          isLoading = _this$state.isLoading;
      return (0, _preact.h)(_ConfigContext.ConfigContext.Consumer, null, function (_ref5) {
        var _ref5$moderationConfi = _ref5.moderationConfig,
            userView = _ref5$moderationConfi.userView,
            userEdit = _ref5$moderationConfi.userEdit,
            userBan = _ref5$moderationConfi.userBan;
        return (0, _preact.h)(_preactPortal.default, {
          into: "body"
        }, (0, _preact.h)(_Modal.Modal, {
          isOpen: true,
          isControl: true,
          size: "medium",
          className: "view-profile-modal"
        }, (0, _preact.h)(_ModalHeader.ModalHeader, {
          title: (0, _preact.h)("div", {
            className: "user-profile__title"
          }, username, "'s profile", isBanned && (0, _preact.h)("span", null, "(banned user)")),
          onClose: onClose
        }), (0, _preact.h)(_ModalBody.ModalBody, null, (0, _preact.h)("div", {
          className: "user-profile__container"
        }, (0, _preact.h)("div", {
          className: "user-profile__actions"
        }, userView && (0, _preact.h)(_Button.default, {
          title: "Visit profile",
          onClick: function onClick() {
            return window.open("/member/profile?userid=".concat(authorId), '_blank');
          }
        }), !isSelf && (0, _preact.h)(_Button.default, {
          title: "Send message",
          onClick: function onClick() {
            return window.open("/privateMessages/overview#conversation/".concat(authorId));
          }
        }), userEdit && author.avatar !== '' && (0, _preact.h)(_Button.default, {
          title: "Delete avatar",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.deleteUserAvatar();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }))
        }), userBan && (0, _preact.h)(_Button.default, {
          title: isBanned ? 'Unban user' : 'Ban user',
          variant: isBanned ? 'secondary' : 'danger',
          disabled: isSelf,
          onClick: isBanned ? banUser : function () {
            return showBanUserModal(true);
          }
        })), (0, _preact.h)("div", {
          className: "user-profile__container--item user-profile__user-card"
        }, (0, _preact.h)("div", {
          className: "user-profile__user-details"
        }, (0, _preact.h)(PostAuthor, {
          author: author,
          badges: badges,
          reputationLevel: reputationLevel,
          rank: rank,
          isBanned: isBanned
        }), (0, _preact.h)("div", {
          className: "user-profile__user-details_statistics"
        }, (0, _preact.h)("div", {
          className: "user-profile__user-details_statistics--social"
        }, (0, _preact.h)(_LabelText.default, {
          label: "Followers",
          description: followers
        }), (0, _preact.h)(_LabelText.default, {
          label: "Following",
          description: following
        })), (0, _preact.h)("div", {
          className: "user-profile__user-details_statistics--contribution"
        }, (0, _preact.h)(_LabelText.default, {
          label: "Topics",
          description: topicCount
        }), (0, _preact.h)(_LabelText.default, {
          label: "Replies",
          description: replyCount
        }), (0, _preact.h)(_LabelText.default, {
          label: "Solved",
          description: answerCount
        })))), email && (0, _preact.h)("div", {
          className: "user-profile__email"
        }, (0, _preact.h)(_inputUnit.Label, {
          isControl: true
        }, "Email"), (0, _preact.h)("div", null, email))), (0, _preact.h)("div", {
          className: "user-profile__container--item user-profile__notes"
        }, (0, _preact.h)(_UserNotes.default, {
          userNotes: userNotes,
          userNoteInput: userNoteInput,
          onChangeUserNoteInput: _this2.onChangeUserNoteInput,
          errors: errors,
          isLoading: isLoading,
          addUserNote: _this2.addUserNote
        })), (0, _preact.h)("div", {
          className: "user-profile__container--item user-profile__about"
        }, (0, _preact.h)(_inputUnit.Label, {
          isControl: true
        }, "About"), (0, _preact.h)("ul", {
          className: "fields"
        }, (0, _preact.h)(ListItem, {
          key: "Member since",
          title: "Member since",
          value: joinDate
        }), profileFields.map(function (profileField) {
          return (0, _preact.h)(ListItem, {
            key: profileField.title,
            title: profileField.title,
            value: profileField.value
          });
        }))), ssoProviders.length > 0 && (0, _preact.h)("div", {
          className: "user-profile__container--item user-profile__sso-providers"
        }, (0, _preact.h)(_inputUnit.Label, {
          isControl: true
        }, "SSO Providers"), (0, _preact.h)("ul", {
          className: "fields"
        }, ssoProviders.map(function (ssoProvider) {
          return (0, _preact.h)(ListItem, {
            key: ssoProvider.id,
            title: ssoProvider.type,
            value: ssoProvider.uid
          });
        })))))));
      });
    }
  }]);
  return ProfileModal;
}(_preact.Component);

var _default = ProfileModal;
exports.default = _default;